var cov_bxniw0fvp = function () {
  var path = "/Users/spana/SHEIN/shineout/src/CardGroup/Item.tsx",
      hash = "04c41e1a22ea19509f9f251d7690d1f3e5aa0919",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/CardGroup/Item.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 25
        },
        end: {
          line: 10,
          column: 35
        }
      },
      "1": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 42
        }
      },
      "2": {
        start: {
          line: 11,
          column: 18
        },
        end: {
          line: 11,
          column: 42
        }
      },
      "3": {
        start: {
          line: 15,
          column: 39
        },
        end: {
          line: 15,
          column: 49
        }
      },
      "4": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 36
        }
      },
      "5": {
        start: {
          line: 16,
          column: 22
        },
        end: {
          line: 16,
          column: 36
        }
      },
      "6": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 21,
          column: 5
        }
      },
      "7": {
        start: {
          line: 25,
          column: 85
        },
        end: {
          line: 25,
          column: 95
        }
      },
      "8": {
        start: {
          line: 26,
          column: 16
        },
        end: {
          line: 26,
          column: 60
        }
      },
      "9": {
        start: {
          line: 27,
          column: 22
        },
        end: {
          line: 27,
          column: 50
        }
      },
      "10": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 34,
          column: 17
        }
      },
      "11": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 40,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        },
        loc: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 12,
            column: 3
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 3
          }
        },
        loc: {
          start: {
            line: 14,
            column: 37
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        },
        loc: {
          start: {
            line: 24,
            column: 11
          },
          end: {
            line: 41,
            column: 3
          }
        },
        line: 24
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 11,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 11,
            column: 42
          }
        }, {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 11,
            column: 42
          }
        }],
        line: 11
      },
      "1": {
        loc: {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 16,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 16,
            column: 36
          }
        }, {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 16,
            column: 36
          }
        }],
        line: 16
      },
      "2": {
        loc: {
          start: {
            line: 31,
            column: 9
          },
          end: {
            line: 33,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 9
          },
          end: {
            line: 31,
            column: 18
          }
        }, {
          start: {
            line: 32,
            column: 10
          },
          end: {
            line: 32,
            column: 120
          }
        }],
        line: 31
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/CardGroup/Item.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Fragment } from 'react';
import classname from 'classnames';
import Checkbox from '../Checkbox/Checkbox';
import { cardGroupClass } from './styles';
import Lazyload from '../Lazyload';

var Item =
/*#__PURE__*/
function (_ref) {
  _inherits(Item, _ref);

  var _super = _createSuper2(Item);

  function Item() {
    _classCallCheck(this, Item);

    return _super.apply(this, arguments);
  }

  _createClass(Item, [{
    key: "handleChange",
    value: function handleChange(value, _, checked) {
      cov_bxniw0fvp.f[0]++;

      var _ref2 = (cov_bxniw0fvp.s[0]++, this.props),
          onChange = _ref2.onChange;

      cov_bxniw0fvp.s[1]++;

      if (onChange) {
        cov_bxniw0fvp.b[0][0]++;
        cov_bxniw0fvp.s[2]++;
        onChange(checked, value);
      } else {
        cov_bxniw0fvp.b[0][1]++;
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(content) {
      cov_bxniw0fvp.f[1]++;

      var _ref3 = (cov_bxniw0fvp.s[3]++, this.props),
          placeholder = _ref3.placeholder,
          container = _ref3.container;

      cov_bxniw0fvp.s[4]++;

      if (!placeholder) {
        cov_bxniw0fvp.b[1][0]++;
        cov_bxniw0fvp.s[5]++;
        return content;
      } else {
        cov_bxniw0fvp.b[1][1]++;
      }

      cov_bxniw0fvp.s[6]++;
      return (
        /*#__PURE__*/
        React.createElement(Lazyload, {
          container: container,
          placeholder: placeholder,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 18,
            columnNumber: 7
          }
        }, content)
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_bxniw0fvp.f[2]++;

      var _ref4 = (cov_bxniw0fvp.s[7]++, this.props),
          style = _ref4.style,
          className = _ref4.className,
          container = _ref4.container,
          children = _ref4.children,
          placeholder = _ref4.placeholder,
          value = _ref4.value,
          others = _objectWithoutProperties(_ref4, ["style", "className", "container", "children", "placeholder", "value"]);

      var cls = (cov_bxniw0fvp.s[8]++, classname(cardGroupClass('item'), className));
      var showCheck = (cov_bxniw0fvp.s[9]++, others.checked !== undefined);
      var content = (cov_bxniw0fvp.s[10]++,
      /*#__PURE__*/
      React.createElement(Fragment, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 29,
          columnNumber: 7
        }
      }, children, (cov_bxniw0fvp.b[2][0]++, showCheck) && (cov_bxniw0fvp.b[2][1]++,
      /*#__PURE__*/
      React.createElement(Checkbox, Object.assign({}, others, {
        onChange: this.handleChange.bind(this, value),
        className: cardGroupClass('checkbox'),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 32,
          columnNumber: 11
        }
      })))));
      cov_bxniw0fvp.s[11]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: style,
          className: cls,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 37,
            columnNumber: 7
          }
        }, this.renderChildren(content))
      );
    }
  }]);

  return Item;
}((React.Component));

export default Item;